// System Switcher JavaScript
document.addEventListener('DOMContentLoaded', function() {
    const systemSwitcher = document.getElementById('systemSwitcher');
    const systemOptions = document.querySelectorAll('.system-option');

    systemOptions.forEach(option => {
        option.addEventListener('click', function(e) {
            e.preventDefault();

            const system = this.dataset.system;
            const systemInfo = JSON.parse(this.dataset.systemInfo);

            // Show loading state
            const button = systemSwitcher;
            const originalContent = button.innerHTML;
            button.innerHTML = '<i class="ti ti-loader-2 me-2"></i>Switching...';
            button.disabled = true;

            // Make AJAX request to switch system
            fetch(window.systemSwitchRoute || '/system/switch', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                    'Accept': 'application/json'
                },
                body: JSON.stringify({ system: system })
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                if (data.success) {
                    // Update button content
                    button.innerHTML = `<i class="${systemInfo.icon} me-2"></i><span class="system-label">${systemInfo.label}</span>`;

                    // Update active state
                    systemOptions.forEach(opt => opt.classList.remove('active'));
                    this.classList.add('active');

                    // Force a full page reload to update the navigation
                    // This ensures the server-side navigation is refreshed with the new system
                    window.location.reload();
                } else {
                    throw new Error(data.message || 'Failed to switch system');
                }
            })
            .catch(error => {
                console.error('System switch error:', error);
                // Restore original button content
                button.innerHTML = originalContent;
                // Show error message
                alert('Failed to switch system: ' + error.message);
            })
            .finally(() => {
                button.disabled = false;
            });
        });
    });

    // Auto-dismiss success messages after 5 seconds
    const successAlerts = document.querySelectorAll('.alert-success');
    successAlerts.forEach(function(alert) {
        setTimeout(function() {
            if (alert && alert.parentNode) {
                const bsAlert = new bootstrap.Alert(alert);
                bsAlert.close();
            }
        }, 5000);
    });

    // Global Select2 initialization for elements with .select2 class
    // Wait for jQuery and Select2 to be available
    function initializeSelect2() {
        if (typeof jQuery !== 'undefined' && typeof jQuery.fn.select2 !== 'undefined') {
            jQuery('.select2').each(function() {
                const $select = jQuery(this);

                if ($select.data('select2Manual') || $select.attr('data-select2-manual') === 'true') {
                    return;
                }
                
                // Skip if already initialized
                if ($select.data('select2')) {
                    return;
                }
                
                const ajaxUrl = $select.attr('data-ajax-url') || $select.data('ajaxUrl');
                const placeholder = $select.data('placeholder') || 'Search...';
                const allowClear = $select.data('allow-clear') !== false;
                const minimumInputLength = $select.data('minimum-input-length') || 0;
                
                // If AJAX URL is provided, use AJAX mode
                if (ajaxUrl) {
                    $select.select2({
                        placeholder: placeholder,
                        allowClear: allowClear,
                        ajax: {
                            url: ajaxUrl,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term, // search term
                                    page: params.page || 1
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data.results || []
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: minimumInputLength
                    });
                } else {
                    // Simple Select2 without AJAX
                    $select.select2({
                        placeholder: placeholder,
                        allowClear: allowClear
                    });
                }
            });
        } else {
            // Retry after a short delay if jQuery/Select2 not yet loaded
            setTimeout(initializeSelect2, 100);
        }
    }
    
    // Initialize Select2 on page load
    initializeSelect2();
    
    // Re-initialize Select2 when tabs are shown (for selects inside hidden tabs)
    document.addEventListener('shown.bs.tab', function (event) {
        // Small delay to ensure the tab content is fully visible
        setTimeout(initializeSelect2, 50);
    });
});